import {
	getTableCouriers,
	getTableCustomerAttr,
	getTableCustomerAttrList,
	getTableCustomerCategory,
	getTableOrderCustomerAttr,
	getTableProvince,
	getTableResponsibleType,
	getTableSellers
} from 'actions'
import ConfirmModal from 'components/common/ConfirmModal'
import NotificationError from 'components/common/notificationsErrors'
import { Form, Formik, FormikProps } from 'formik'
import { getValidationSchema } from 'lib/FieldValidations'
import { getFiltersData } from 'lib/Utils'
import {
	ICustomerAttributesGlobalUploadFormProps,
	ICustomerAttributesGlobalUploadFormState
} from 'models/CustomerGlobalUploadInterface'
import React, { Component, Fragment } from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import CustomerAttributesGlobalUploadDropDownField from './CustomerAttributesGlobalUploadDropDownFields'
import CustomerAttributesGlobalUploadFieldsSelect from './CustomerAttributesGlobalUploadFieldsSelect'
import CustomerAttributesGlobalUploadFormField from './CustomerAttributesGlobalUploadFormFields'

class CustomerAttributesGLobalUploadForm extends Component<
	ICustomerAttributesGlobalUploadFormProps,
	ICustomerAttributesGlobalUploadFormState
> {
	constructor(props: ICustomerAttributesGlobalUploadFormProps) {
		super(props)
		this.state = {
			listState: false
		}
	}

	componentDidMount = () => {
		this.props.getTableResponsibleType({ incluye_todos: 1 })
		this.props.getTableProvince({ incluye_todos: 1 })
		this.props.getTableCouriers({ incluye_todos: 1 })
		this.props.getTableSellers({ incluye_todos: 1 })
		this.props.getTableCustomerCategory({ incluye_todos: 1 })
		this.props.getTableCustomerAttr()
		this.props.getTableOrderCustomerAttr()
	}

	componentDidUpdate = (
		prevProps: ICustomerAttributesGlobalUploadFormProps
	) => {
		const { attributesList, catributoValues, catributoListValues } = this.props
		const {
			attributesList: prevAtributesList,
			catributoListValues: prevCatributoListValues
		} = prevProps

		if (prevCatributoListValues !== catributoListValues) {
			catributoListValues && _.isEmpty(catributoListValues.lista)
				? this.setState({ listState: false })
				: this.setState({ listState: true })
		}

		if (
			prevAtributesList !== attributesList &&
			attributesList.lista &&
			attributesList.lista.length > 0
		) {
			_.each(attributesList.lista, (atribute) => {
				atribute.descrip =
					catributoValues.lista.find(
						(value) => value.codigo === atribute.codigo
					)?.descrip || atribute.codigo
			})
		}
	}

	handleAttributeListValues = (idAttribute: any) => {
		idAttribute &&
			this.props.getTableCustomerAttrList({
				catributo: idAttribute
			})
	}

	render() {
		const {
			t,
			fields,
			handleSubmit,
			handleButtonSubmit,
			handleButtonClean,
			handleGlobalAssign,
			idOperacion,
			disableForm
		} = this.props
		const { listState } = this.state

		const initialValues = {
			idOperacion: idOperacion,
			page_size: 10,
			page_number: 1,
			orden: 1,
			rsoc: '',
			codigo: '',
			categoria: '',
			tipo_resp: '',
			atributos: ''
		}

		const validationSchema = fields.length
			? getValidationSchema(fields, t, [], [])
			: {}

		const checkboxFields = fields
			? getFiltersData(fields, { agrupador: 'checkbox' })
			: []
		const dropdownFields = fields
			? getFiltersData(fields, { agrupador: 'drop_down' })
			: []
		const formFields = fields
			? getFiltersData(fields, { agrupador: 'formulario' })
			: []

		return (
			<Formik
				initialValues={initialValues}
				onSubmit={(values) => {
					handleSubmit(values)
				}}
				enableReinitialize={true}
				validationSchema={validationSchema}
			>
				{(props: FormikProps<any>) => (
					<Fragment>
						<Col sm={12}>
							<NotificationError
								errors={props.errors}
								touched={props.touched}
							/>
						</Col>
						<Col sm={12}>
							<Alert variant={'dark'}>
								<b>{t('CRUDS.general_use.attr_to_show')}</b>
							</Alert>
						</Col>
						<Form className="container-fluid">
							<Row className="row justify-content-md-center">
								<Col sm={3} className={'ml-3'}>
									<Row className="justify-content-center text-center">
										<h6>{t('form.header.step-1')}</h6>
									</Row>
									<Col sm={12}>
										{!_.isEmpty(checkboxFields) &&
											_.map(checkboxFields, (field) => {
												return (
													<CustomerAttributesGlobalUploadFieldsSelect
														field={field}
														formikProps={props}
														crudProps={this.props}
														initialValue={initialValues}
													/>
												)
											})}
									</Col>
								</Col>
								<Col lg={3} className={'text-center, mx-3'}>
									<Row className="justify-content-center text-center">
										<h6>{t('form.header.step-2')}</h6>
									</Row>
									<Row>
										{!_.isEmpty(dropdownFields) &&
											_.map(dropdownFields, (field) => {
												return (
													<CustomerAttributesGlobalUploadDropDownField
														field={field}
														formikProps={props}
														crudProps={this.props}
														initialValue={initialValues}
													/>
												)
											})}
									</Row>
									<Row className="justify-content-center text-center">
										<Button
											style={{
												minWidth: '145px',
												margin: '20px',
												marginTop: '10px'
											}}
											type={'submit'}
											onClick={() => handleSubmit}
											disabled={disableForm}
										>
											{t('Collection.form.buttons.apply')}
										</Button>
										<Button
											style={{
												minWidth: '145px',
												margin: '20px',
												marginTop: '10px'
											}}
											type={'button'}
											onClick={() => {
												props.resetForm()
												handleButtonClean()
											}}
											disabled={!disableForm}
										>
											{t('Collection.form.buttons.clean')}
										</Button>
									</Row>
								</Col>
								<Col sm={3} className={'text-center, mx-3'}>
									<Row className="justify-content-center text-center">
										<h6>{t('form.header.step-3')}</h6>
									</Row>
									<Row>
										{!_.isEmpty(formFields) &&
											_.map(formFields, (field) => {
												return (
													<CustomerAttributesGlobalUploadFormField
														field={field}
														formikProps={props}
														crudProps={this.props}
														initialValue={initialValues}
														listState={listState}
														handleAttributeListValues={
															this.handleAttributeListValues
														}
													/>
												)
											})}
									</Row>
									<Row className="justify-content-center text-center">
										<Button
											style={{
												minWidth: '145px',
												margin: '20px'
											}}
											type={'button'}
											onClick={() => {
												handleGlobalAssign(props.values)
											}}
											disabled={!disableForm}
										>
											{t('Collection.form.buttons.asign_values')}
										</Button>
										<ConfirmModal
											messageBody={<div>{t('CRUDS.modal.body_warning')}</div>}
											onSubmitModal={() => {
												handleButtonSubmit()
											}}
											typeButton="button"
											modalTitle={t('CRUDS.modal.title_warning')}
											labelButton={t('global.confirm')}
											buttonStyle={{
												minWidth: '145px',
												margin: '20px'
											}}
										/>
									</Row>
								</Col>
							</Row>
						</Form>
					</Fragment>
				)}
			</Formik>
		)
	}
}
const mapStateToProps = ({ tableCalls }: any) => {
	const {
		customerCategory,
		responsibleType,
		documentType,
		province,
		country,
		couriers,
		termsOfSales,
		sellers,
		priceList,
		credit,
		foreignCurrencies,
		conceptsBackgrounds,
		branchOffices,
		generationType,
		voucherType,
		orderCustomerAttr,
		catributoValues,
		catributoListValues
	} = tableCalls

	return {
		customerCategory,
		responsibleType,
		documentType,
		province,
		country,
		couriers,
		termsOfSales,
		sellers,
		priceList,
		credit,
		foreignCurrencies,
		conceptsBackgrounds,
		branchOffices,
		generationType,
		voucherType,
		orderCustomerAttr,
		catributoValues,
		catributoListValues
	}
}

const connectForm = connect(mapStateToProps, {
	getTableResponsibleType,
	getTableProvince,
	getTableCouriers,
	getTableSellers,
	getTableCustomerCategory,
	getTableOrderCustomerAttr,
	getTableCustomerAttr,
	getTableCustomerAttrList
})(CustomerAttributesGLobalUploadForm)

export default withTranslation()(withRouter(connectForm))
